import {
    AckoMainTheme,
    ThemeProvider,
} from '@acko-tech/building-blocks.ui.theme';
import Dashboard from 'components/dashboard';
import ManageDealers from 'components/manageDealers';
import NewPlan from 'components/newPlan';
import Payment from 'components/payment';
import Transactions from 'components/transactions';
import ErrorPage from 'widgets/errorScreen';
import ContactUs from 'components/contactUs';
import { useFetchParams } from 'hooks/useFetchParams';

// routes
import getRoutePathAther from 'components/routesConfig/ather';

// components
import DealerDetails from 'components/dealerDetails';
import LegalDocumentsUpload from 'components/legalDocuments';
import LegalTnc from 'components/legalTnc';
import DashboardV2 from 'components/dashboardV2';
import ThankYouPage from 'components/thankYouPage';
import CommissionListingV0 from 'components/CommissionListing';
import CommissionListingV1 from 'components/CommissionListingV1';
import GSTDetails from 'components/gstDetails';
import ReportDashboard from 'components/reportDashboard';
import Details from 'components/details';
import WalletTransactions from 'components/walletTransactions';
import PaymentMode from 'components/paymentMode';
import ServiceCenterOnboarding from 'components/serviceCenterOnboarding';

function Routes() {
    const { route, lob } = useFetchParams();
    function getRoutePath(route) {
        switch (route) {
            case 'dashboard':
                return <Dashboard />;
            case 'commissions-earned':
                return <CommissionListingV0 />;
            case 'commissions-earned-v1':
                return <CommissionListingV1 showHeader={true} />;
            case 'manage-dealers':
                return <ManageDealers />;
            case 'new-plan':
                return <NewPlan />;
            case 'payment':
                return <Payment />;
            case 'payment-mode':
                return <PaymentMode />;
            case 'transactions':
                return <Transactions />;
            case 'thankyou':
                return <ThankYouPage />;
            case 'contact-us':
                return <ContactUs />;
            case 'legal-documents':
                return <LegalDocumentsUpload />;
            case 'gst-details':
                return <GSTDetails />;
            case 'details':
                return <Details />;
            case 'legal-tnc':
                return <LegalTnc />;
            case 'report-dashboard':
                return <ReportDashboard />;
            case 'dealer-details':
                return <DealerDetails />;
            case 'wallet-transactions':
                return <WalletTransactions />;
            case 'service-partner':
                return <ServiceCenterOnboarding />;
            default:
                return (
                    <ErrorPage
                        errorCode={404}
                        errorMessage={'Page not found'}
                    />
                );
        }
    }

    function getRoutePathPartnership() {
        switch (route) {
            case 'dashboard':
                return <DashboardV2 />;
            case 'manage-dealers':
                return <ManageDealers />;
            case 'contact-us':
                return <ContactUs />;
            case 'transactions':
                return <Transactions />;
            case 'payment-mode':
                return <PaymentMode />;
            case 'dealer-details':
                return <DealerDetails />;
            case 'details':
                return <Details />;
            default:
                return (
                    <ErrorPage
                        errorCode={404}
                        errorMessage={'Page not found'}
                    />
                );
        }
    }

    const getRouteFunction = () => {
        switch (lob) {
            case 'auto-lob':
                return getRoutePathAther;
            case 'auto-partnership':
                return getRoutePathPartnership;
            case 'embedded':
            default:
                return getRoutePath;
        }
    };

    const renderComponent = getRouteFunction();

    return (
        <ThemeProvider theme={AckoMainTheme}>
            {renderComponent(route)}
        </ThemeProvider>
    );
}

export default Routes;
